export default __webpack_public_path__ + "static/media/SchedulerOff.c8b1e595.svg";